import store from '../../store';
import SystemNotificator from "@/services/SystemNotificator";

/**
 * Middleware którego zadaniem jest oczekiwanie na załadowanie się aplikacji
 * @param next
 */
export default function ({next, to}) {

    if (to.query.hasOwnProperty('errorMessage')) {
        SystemNotificator.error({title: 'Błąd', message: to.query.errorMessage});
    }

    // Jeśli token ze store jest już zweryfikowany
    // to od razu przechodzimy dalej
    if (store.state.Auth.storedTokenChecked) {
        return next();
    }

    if (process.env.VUE_APP_FORCE_HTTPS && location.protocol !== 'https:' && !location.hostname.endsWith('.dcrm')) {
        location.replace(`https:${location.href.substring(location.protocol.length)}`);
        return;
    }

    // Jeśli token nie został jeszcze zweryfikowany
    // następuje jego weryfikacja
    store.dispatch('Auth/checkStoredToken')
        .then(() => next())
        .catch(() => next());
}